import React from "react";
import moment from "moment";
import attachIcon from "../../../asset/images/attach.svg";
import { toSentenceCase } from "../../../CommonMethhods/CommonMethods";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

function HistoryPreview({ batch, onClose }) {
  const getStatusClass = (status = "") => {
    switch (status.toLowerCase()) {
      case "approved":
        return "status-approved";
      case "rejected":
        return "status-rejected";
      case "pending":
        return "status-pending";
      default:
        return "";
    }
  };

  return (
    <div className="step-content mb-extra history-preview-card">
      <div className="preview-wrapper">

        {/* Header */}
        <div className="summary-title-wrap">
          <span className="summary-title">
            Batch Details
          </span>

          <div className="wrap-upload">
            <span className="records">
              {batch.count} RECORDS
            </span>

            <button
              className="back-btn"
              onClick={onClose}
            >
              CLOSE
            </button>
          </div>
        </div>

        {/* Batch Header */}
        <div className="client-header mb-15">

          <div className="client-wrapper">
            <div className="cl-wrapper">
              <span className="cl-name">
                {batch.batchId}
              </span>

              <div className="client-code">
                Requested on{" "}
                {moment(batch.requestDate).format("DD-MM-YYYY")}
              </div>
            </div>
          </div>

          <div className="checker-actions mapping-footer-actions new-filename">

            {/* {batch.approvalDocFilename && (
              <span
                className="checker-document doc-name-hover"
                onClick={() =>
                  window.open(batch.approvalDocLink, "_self", "noopener,noreferrer")
                }
                title={batch.approvalDocFilename}
              >
                <img
                  src={attachIcon}
                  alt=""
                />
                {batch.approvalDocFilename}
              </span>
            )} */}

            {batch.approvalDocFilename && (
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip
                    id="file-tooltips"
                    // className="file-tooltip"
                  >
                    {batch?.approvalDocFilename}
                  </Tooltip>
                }
              >
                <span
                  className="checker-document"
                  onClick={(e) => {
                    e.stopPropagation();
                    window.open(batch?.approvalDocLink, "_self", "noopener,noreferrer");
                  }}
                >
                  <img src={attachIcon} alt="attach icon" />
                  <span className="file-name">{batch?.approvalDocFilename}</span>
                </span>
              </OverlayTrigger>
            )}

          </div>
        </div>

        {/* Table */}

        <div className="ckr-table-wrapper dl-checker-table">

          <table className="ckr-table draft-maker">

            <thead>
              <tr>
                <th>Request Date</th>
                <th>Checker ID</th>
                <th>UCC / Client Code</th>
                <th>New Dealer Code</th>
                <th>Effective Date</th>
                <th>Status</th>
                <th>Remarks</th>
              </tr>
            </thead>

            <tbody>

              {batch.requests.map((row) => (
                <tr key={row.requestId}>

                  <td>
                    {moment(row.reqDate).format("DD-MM-YYYY")}
                  </td>

                  <td>
                    {row.checkerId || "-"}
                  </td>

                  <td>
                    {row.ucc}
                  </td>

                  <td>
                    {row.newDealerCode}
                  </td>

                  <td>
                    {moment(row.startDate).format("DD-MM-YYYY")}
                  </td>

                  <td>
                    <span
                      className={getStatusClass(
                        row.approvalStatus
                      )}
                    >
                      {toSentenceCase(row?.approvalStatus)}
                    </span>
                  </td>

                  <td>
                    {row.rejectionReason?.length > 0
                      ? row.rejectionReason.join(", ")
                      : "-"}
                  </td>

                </tr>
              ))}

            </tbody>

          </table>

        </div>

      </div>
    </div>
  );
}

export default HistoryPreview;